import { Tag } from './Tag.js';

/**
 * 里程碑倒计时角标（技术路线 §7.6 规则）：
 * - daysLeft 为 null（无法解析）或 < 0（已过期）→ 不渲染角标；
 * - daysLeft ≤ 2 → 红色（紧急）；≤ 7 → 橙色（临近）；否则灰色（常规）。
 * daysLeft 一律来自后端（GET /events/:code/timeline 实时计算），前端不做日期运算。
 */
export function CountdownBadge({ daysLeft }: { daysLeft: number | null }) {
  if (daysLeft === null || daysLeft < 0) return null;
  if (daysLeft === 0) {
    return (
      <Tag tone="danger" title="今天截止">
        今天截止
      </Tag>
    );
  }
  if (daysLeft <= 2) {
    return (
      <Tag tone="danger" title={`还剩 ${daysLeft} 天`}>
        剩 {daysLeft} 天
      </Tag>
    );
  }
  if (daysLeft <= 7) {
    return (
      <Tag tone="warn" title={`还剩 ${daysLeft} 天`}>
        剩 {daysLeft} 天
      </Tag>
    );
  }
  return (
    <Tag tone="muted" title={`还剩 ${daysLeft} 天`}>
      剩 {daysLeft} 天
    </Tag>
  );
}
